/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Fail_LabelInputs */



/**
* | output |
* | --- |
* | "Fail selected events" |
*
* @param {Context_Menu_Fail_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_fail_label = /** @type {((inputs?: Context_Menu_Fail_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Fail_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rejeter les événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse fehlschlagen lassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eventi selezionati non riusciti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отклонить выбранные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallar eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败的选定事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントを失敗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं में विफलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha nos eventos selecionados")
	return /** @type {LocalizedString} */ ("Fail selected events")
});